<div style="display: block">
    <section class="content">
        <h3>{{ 'macros_calories' | localise }}</h3>
        <p>{{ 'macros_calories_text' | localise }}</p>

        <div class="form-group">
            <div class="col-md-12 grid-margin" style="padding: 0; display: flex; margin: 0; margin-top: 30px; margin-bottom: -4px;">
                <div class="col-3">
                    <div class="form-group">
                        <label class="font-weight-bold">{{ 'daily_calories' | localise }}</label>
                        <input type="number" step="1" class="form-control" [placeholder]="'enter_calories' | localise"
                               [formControl]="overwrite_all_calories"/>
                    </div>
                </div>

                <div class="col-3">
                    <div class="form-group">
                        <label class="font-weight-bold">{{ 'protein' | localise }}</label>
                        <input type="number" step="1" class="form-control" [placeholder]="'enter_protein' | localise"
                               [formControl]="overwrite_protein"/>
                    </div>
                </div>

                <div class="col-3">
                    <div class="form-group">
                        <label class="font-weight-bold">{{ 'carbs' | localise }}</label>
                        <input type="number" step="1" class="form-control" [placeholder]="'enter_carbs' | localise"
                               [formControl]="overwrite_carbs"/>
                    </div>
                </div>

                <div class="col-3">
                    <div class="form-group">
                        <label class="font-weight-bold">{{ 'fats' | localise }}</label>
                        <input type="number" step="1" class="form-control" [placeholder]="'enter_fats' | localise"
                               [formControl]="overwrite_fat"/>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <hr />

    <section class="content">
        <h3>{{ 'daily_daily_macros_calories' | localise }}</h3>
        <p>{{ 'daily_daily_macros_calories_text' | localise }}</p>

        <div class="form-group">
            <div class="col-md-12 grid-margin" style="paddng:0 !important; margin: 0 !important; margin-top: 30px; margin-bottom: -4px;">

                <div class="row macro-row" *ngFor="let dailyMacrosViewModel of daily_overwrites; let i = index">
                    <div class="col-4">
                        <div class="form-group daily_macro_day">
                            <button class="btn btn-sm btn-danger" (click)="removeDailyMacro(i)"><i class="ti-close"></i></button>
                            <button class="btn btn-sm btn-primary" (click)="duplicateDailyMacro(i)"><i class="fa fa-copy"></i></button>

                            <select required="required" (change)="onDayChange($event, i)" class="form-control">
                                <option value="">{{ 'DAY' | localise }}</option>
                                <option
                                        [selected]="dailyMacrosViewModel.day && 'MON' === dailyMacrosViewModel.day"
                                        value="MON">{{'monday' | localise}}
                                </option>
                                <option
                                        [selected]="dailyMacrosViewModel.day && 'TUE' === dailyMacrosViewModel.day"
                                        value="TUE">{{'tuesday' | localise}}
                                </option>
                                <option
                                        [selected]="dailyMacrosViewModel.day && 'WED' === dailyMacrosViewModel.day"
                                        value="WED">{{'wednesday' | localise}}
                                </option>
                                <option
                                        [selected]="dailyMacrosViewModel.day && 'THU' === dailyMacrosViewModel.day"
                                        value="THU">{{'thursday' | localise}}
                                </option>
                                <option
                                        [selected]="dailyMacrosViewModel.day && 'FRI' === dailyMacrosViewModel.day"
                                        value="FRI">{{'friday' | localise}}
                                </option>
                                <option
                                        [selected]="dailyMacrosViewModel.day && 'SAT' === dailyMacrosViewModel.day"
                                        value="SAT">{{'saturday' | localise}}
                                </option>
                                <option
                                        [selected]="dailyMacrosViewModel.day && 'SUN' === dailyMacrosViewModel.day"
                                        value="SUN">{{'sunday' | localise}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="col-8 right-column">
                        <div class="form-group">
                            <label class="font-weight-bold">
                                Брой хранения
                                <button (click)="openChangeMealPercentage(i)" class="modify-daily-meal btn btn-block btn-sm btn-secondary">Модифицирай</button>
                            </label>

                            <select required="required" (change)="onDailyMealChange($event, i)"  class="form-control">
                                <option value="">- - от системата автоматично - -</option>
                                <option
                                        *ngFor="let dailyMeal of dailyMeals"
                                        [selected]="dailyMacrosViewModel.daily_meal_id === dailyMeal.id"
                                        [value]="dailyMeal.id">{{ dailyMeal.title }}
                                </option>
                            </select>


                        </div>

                        <div class="form-group">
                            <label class="font-weight-bold">{{ 'daily_calories' | localise }}</label>
                            <input type="number" step="1" class="form-control" [value]="dailyMacrosViewModel.overwrite_all_calories" (change)="changeDailyMacroCalories($event, i)" [placeholder]="'enter_calories' | localise"/>
                        </div>

                        <div class="form-group">
                            <label class="font-weight-bold">{{ 'protein' | localise }}</label>
                            <input type="number" step="1" class="form-control" [value]="dailyMacrosViewModel.overwrite_protein" (change)="changeDailyMacroProtein($event, i)" [placeholder]="'enter_protein' | localise"/>
                        </div>

                        <div class="form-group">
                            <label class="font-weight-bold">{{ 'carbs' | localise }}</label>
                            <input type="number" step="1" class="form-control" [value]="dailyMacrosViewModel.overwrite_carbs" (change)="changeDailyMacroCarbs($event, i)" [placeholder]="'enter_carbs' | localise"/>
                        </div>

                        <div class="form-group">
                            <label class="font-weight-bold">{{ 'fats' | localise }}</label>
                            <input type="number" step="1" class="form-control" [value]="dailyMacrosViewModel.overwrite_fat" (change)="changeDailyMacroFat($event, i)" [placeholder]="'enter_fats' | localise"/>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-6 col-xs-12">
                        <button (click)="addNewDailyMacro()" class="btn btn-sm btn-success add-new-training">
                            <i class="ti-plus"></i>
                            {{ 'enter_new_day' | localise }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>


    <div >
        <button (click)="updateProfile()" class="btn btn-block btn-primary">{{ 'save' | localise }}</button>
    </div>
</div>
